import mime from 'mime/lite'

export function getFileMimeType(file: { type?: string; name: string }): string {
  if (file.type) {
    return file.type
  }

  return mime.getType(file.name) ?? 'application/octet-stream'
}
